import { urlSecurity } from './constants'

export const handleScriptLoad = () => {
  const existingScript = document.querySelector(`script[src="${urlSecurity}"]`)

  if (existingScript) return

  const script = document.createElement('script')
  script.src = urlSecurity
  script.setAttribute('view', 'checkout')
  script.async = true
  document.head.appendChild(script)
}
